// extracted by mini-css-extract-plugin
export var container = "_87-0";